export default __webpack_public_path__ + "static/media/people-group-outline.6aae3cc3.svg";